import React from "react";
import {ContractItem} from "../Components/ContractItem";
import {addItem, deleteItem, setChangedItem} from "../store/actions/cart_actions";
import {connect} from "react-redux";
import AllOrder , {getMonth} from "./AllOrder";
import {setOrder} from "../store/actions/order_actions";
import {today_date} from "./Header";

class PersonalArea extends React.Component{
    constructor(props){
        super(props);
        this.handleChangeField = this.handleChangeField.bind(this);

        let contracts = [con];
        this.state = {
            contracts: contracts,
        };
    }


    handleChangeField = () => (event, newExpanded) => {
        newExpanded ?this.setState({expanded: false,close: false}): this.setState({expanded: false,close: false})
    };

    render() {
        const{order} = this.props;
        let now_date = getMonth(new Date().getMonth());
        let last_date = getMonth(new Date().getMonth()-1);
        return (
            <main id={"personal_area"}>
                    <div id={'personal_area_mobile'}>
                        <div className={"title_container"}>
                            <p >Личный кабинет</p>
                        </div>
                        <div>
                            {this.state.contracts.map((position, index) => (
                                <ContractItem data={position} key={index}/>
                            ))}
                        </div>
                    </div>
                    <div id={'personal_area_desktop'}>
                        <div className={"title_container"}>
                            <p >Аналитика заявок - ({today_date.getDate() + "." + Number(today_date.getMonth()+1) + '.' + today_date.getFullYear()})</p>
                        </div>
                        <div id={"order_analytic"}>
                            <div className={'order_analytic_position'}>
                                <div>
                                    Выполнено услуг
                                </div>
                                <div>
                                    <p>Экспресс-обмен:</p>
                                    <p>{order.express} шт.</p>
                                </div>
                                <div>
                                    <p>Заправка:</p>
                                    <p>{order.priming} шт.</p>
                                </div>
                            </div>
                            <div className={'order_analytic_position mean_time'}>
                                <div>
                                    Среднее время выполнения заявки
                                </div>
                                <div>
                                    <span>{Math.ceil(order.mean_time)}</span>
                                    <p>минут</p>
                                </div>
                            </div>
                            <div className={'order_analytic_position'}>
                                <div>
                                    Количество активных заявок
                                </div>
                                <div>
                                    <p><span>{last_date.month} </span>{last_date.name}</p>
                                    <p>{order.active_order_before}</p>
                                </div>
                                <div>
                                    <p><span>{now_date.month} </span>{now_date.name}</p>
                                    <p>{order.active_order_now}</p>
                                </div>
                            </div>
                            <div className={'order_analytic_position'}>
                                <div>
                                    По расходам
                                </div>
                                <div>
                                    <p>Выполнено:</p>
                                    <p>{Math.ceil(order.ready_order_price)} руб.</p>
                                </div>
                                <div>
                                    <p>Оплачено:</p>
                                    <p>{Math.ceil(order.payment_order)} руб.</p>
                                </div>
                            </div>
                        </div>
                        <AllOrder />
                    </div>
            </main>
        )
    }
}
const con = {name: 'Активный контракт',
    info: ["Почта России","Активный","Москва, Россия","10.02.2020 - 31.07.2020","200 000 000.00","",]};

const mapStateToProps = store => {
    return{
        cart: store.cart,
        order: store.order
    }
};

const mapDispatchToProps = dispatch => {
    return{
        setChangedItem: (id, flag) => dispatch(setChangedItem(id, flag)),
        deleteItem: (id) => dispatch(deleteItem(id)),
        addItem: (id) => dispatch(addItem(id)),
        setOrder: (order) => dispatch(setOrder(order))
    }
};

export default connect(mapStateToProps,mapDispatchToProps)(PersonalArea)
